/* eslint-disable no-unused-vars */
/* eslint-disable no-promise-executor-return */
/* eslint-disable consistent-return */
/* eslint-disable no-console */

import { CacheSizeProvider } from "./CacheSizeProvider.js";

export const calculateIndexedDBSize = () => {
  const cacheProvider = CacheSizeProvider();
  const DBNames = ["TTFREVIEW"];

  const getTableSize = (openedDBResult, tableName) => {
    return new Promise((resolve, reject) => {
      if (openedDBResult == null) {
        return reject();
      }
      let DBSize = 0;

      const transaction = openedDBResult
        .transaction([tableName])
        .objectStore(tableName)
        .openCursor();

      transaction.onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          const storedObject = cursor.value;
          const json = JSON.stringify(storedObject);
          DBSize += json.length;

          const keys = Object.keys(storedObject);
          const values = Object.values(storedObject);
          for (let i = 0; i < keys.length; i += 1) {
            if (values[i] instanceof Blob) {
              DBSize += values[i].size;
            }
          }
          cursor.continue();
        } else {
          resolve(DBSize);
        }
      };
      transaction.onerror = (err) => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(`error in ${tableName}: ${err}`);
      };
    });
  };

  const humanReadableSize = (bytes) => {
    const thresh = 1024;
    let copyBytes = bytes;
    if (Math.abs(bytes) < thresh) {
      return `${bytes} B`;
    }
    const units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let u = -1;
    do {
      copyBytes /= thresh;
      u += 1;
    } while (Math.abs(copyBytes) >= thresh && u < units.length - 1);
    return `${copyBytes.toFixed(1)} ${units[u]}`;
  };

  DBNames.forEach((DBName) => {
    const request = indexedDB.open(DBName);
    request.onerror = (event) => {
      console.log("Why didn't you allow my web app to use IndexedDB");
    };

    request.onsuccess = (event) => {
      const openedDBResult = event?.target?.result;
      const tableNames = openedDBResult?.objectStoreNames;
      const tableNamesArray = Array.from(tableNames);

      const tableSizeGetters = tableNamesArray.reduce((acc, tableName) => {
        const promise = getTableSize(openedDBResult, tableName);
        acc.push(promise);
        return acc;
      }, []);

      Promise.all(tableSizeGetters).then((sizes) => {
        const total = sizes.reduce((acc, val) => {
          return acc + val;
        }, 0);

        tableNamesArray.forEach((tableName, i) => {
          const payload = {
            size: total,
            humanReadableFormat: humanReadableSize(total)
          };
          cacheProvider.setItem(DBName, payload);
        });
      });
    };
  });
};
